<button
    ds-button-icon
    kind="tertiary"
    variant="flat-reduced"
    size="small"
    class="info-icon"
    [ngClass]="selected ? 'selected' : 'deselected'"
    (click)="toggleHelp($event)">
    <vn-icon size="12" [name]="selected ? 'theme-info-i' : 'theme-info'" />
</button>
